import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type SurveyContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null, bookmark?: { id: string } | null };


export type SurveyContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type SurveyContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null, bookmark?: { id: string } | null };


export type SurveyContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SurveyContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment SurveyContentCard on SurveyContentType {
  id
  name
  type
  duration
  description
  cover {
    ...EntityMedia
  }
  performance {
    id
    status
    progress
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
  bookmark {
    id
  }
}
    `;
export const SurveyContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment SurveyContentCardWithUserPerformance on SurveyContentType {
  id
  name
  type
  duration
  description
  cover {
    ...EntityMedia
  }
  performance(userId: $userId) {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
  bookmark {
    id
  }
}
    `;